import { useSyncExternalStore } from 'react'
import { useReveal } from '../hooks/useReveal.js'

const MOBILE_DELAY_CAP_MS = 200
const MOBILE_MQ = '(max-width: 640px)'
const REDUCE_MQ = '(prefers-reduced-motion: reduce)'
const COARSE_MQ = '(pointer: coarse)'

function subscribeMedia(query, onChange) {
  const mq = window.matchMedia(query)
  mq.addEventListener('change', onChange)
  return () => mq.removeEventListener('change', onChange)
}

function useMediaQuery(query) {
  return useSyncExternalStore(
    (onChange) => subscribeMedia(query, onChange),
    () => window.matchMedia(query).matches,
    () => false,
  )
}

/** Cap / shorten stagger delays on mobile per audit §3 (~200–250ms max). */
function resolveRevealDelay(delay, { isMobile, reduceMotion }) {
  if (reduceMotion || delay <= 0) return 0
  if (isMobile) return Math.min(Math.round(delay * 0.5), MOBILE_DELAY_CAP_MS)
  return delay
}

export function Reveal({ children, delay = 0, className = '', as: Tag = 'div' }) {
  const { ref, visible } = useReveal({ threshold: 0.06 })
  const isMobile = useMediaQuery(MOBILE_MQ)
  const reduceMotion = useMediaQuery(REDUCE_MQ) || useMediaQuery(COARSE_MQ)
  const resolvedDelay = resolveRevealDelay(delay, { isMobile, reduceMotion })

  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? 'visible' : ''} ${className}`}
      style={{ transitionDelay: `${resolvedDelay}ms` }}
    >
      {children}
    </Tag>
  )
}
